<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <div
    class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
  >
    <!-- Left Side -->
    <div class="flex-1 min-w-0">
      <div class="flex">
        <a
          class="inline-flex items-center -ml-1.5 text-secondary font-medium"
          [routerLink]="'/dashboard'"
        >
          <mat-icon
            class="icon-size-5 text-secondary"
            [svgIcon]="'heroicons_solid:chevron-left'"
          ></mat-icon>
          <span class="ml-1">Back</span>
        </a>
      </div>
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          {{ "User Profile" }}
        </h2>
      </div>
    </div>

    <!-- Right Side -->
    <div
      class="flex flex-col sm:flex-row shrink-0 items-end sm:items-center self-end mt-6 sm:mt-0 sm:ml-4 space-y-3 sm:space-y-0 sm:space-x-3"
      *ngIf="userRecord"
    >
      <!-- Delete button -->
      <button
        mat-flat-button
        (click)="updateSubscription('Cancelled')"
        color="warn"
      >
        Delete Profile
      </button>

      <!-- Edit button -->
      <button
        mat-raised-button
        color="primary"
        aria-label="EditCount"
        type="button"
        *ngIf="updateBtn === true"
        (click)="clickEdit()"
      >
        Edit
      </button>
    </div>
  </div>

  <!-- Show message when no userRecord exists -->
  <div
    *ngIf="!userRecord"
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card flex items-center justify-center"
  >
    <div class="text-center">
      <mat-icon class="icon-size-16 text-gray-400 mb-4">info</mat-icon>
      <h3 class="text-xl font-semibold text-gray-600 mb-2">No Profile Found</h3>
      <p class="text-gray-500">No Membership has been done yet.</p>
    </div>
  </div>

  <!-- Show profile view when userRecord exists and updateBtn is true -->
  <div
    *ngIf="userRecord && updateBtn === true"
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
    cdkScrollable
  >
    <div class="my-5 border-t"></div>

    <div class="profile-image-container">
      <img
        [src]="
          imagePreviewParent
            ? imagePreviewParent
            : 'assets/images/avatars/user.png'
        "
        alt="Parent Image"
        class="profile-image"
      />

      <div>
        <!-- <mat-label class="font-bold pl-3">{{ userRecord.Name }}</mat-label> -->
      </div>
    </div>

    <div>
      <div class="grid sm:grid-cols-12 gap-6 w-full mt-8">
        <div class="sm:col-span-3">
          <mat-label class="font-bold">Full Name</mat-label>
          <h2>{{ userRecord.Name }}</h2>
        </div>

        <div class="sm:col-span-3">
          <mat-label class="font-bold">Email Address</mat-label>
          <h2>{{ userRecord.Parent_Email__c }}</h2>
        </div>

        <!-- <div class="sm:col-span-3">
          <mat-label class="font-bold">Community</mat-label>
          <h2>{{ userRecord.Community__r?.Name }}</h2>
        </div> -->

        <div class="sm:col-span-3" *ngIf="userRecord.Physical_Address__c">
          <mat-label class="font-bold">Physical Address</mat-label>
          <h2>
            {{
              userRecord.Physical_Address__c === "null"
                ? ""
                : userRecord.Physical_Address__c
            }}
          </h2>
        </div>
      </div>

      <div class="grid sm:grid-cols-12 gap-6 w-full mt-8">
        <div class="sm:col-span-3" *ngIf="userRecord.Town_City__c">
          <mat-label class="font-bold">Town/City</mat-label>
          <h2>
            {{
              userRecord.Town_City__c === "null" ? "" : userRecord.Town_City__c
            }}
          </h2>
        </div>

        <div class="sm:col-span-3" *ngIf="userRecord.Postal_Code__c">
          <mat-label class="font-bold">Postal Code</mat-label>
          <h2>
            {{
              userRecord.Postal_Code__c === "null"
                ? ""
                : userRecord.Postal_Code__c
            }}
          </h2>
        </div>

        <div class="sm:col-span-3">
          <mat-label class="font-bold">Primary Phone</mat-label>
          <h2>
            {{
              userRecord.Home_Phone__c === "null"
                ? ""
                : userRecord.Home_Phone__c
            }}
          </h2>
        </div>

        <div class="sm:col-span-3" *ngIf="userRecord.Cell_Phone__c">
          <mat-label class="font-bold">Cell Phone</mat-label>
          <h2>
            {{
              userRecord.Cell_Phone__c === "null"
                ? ""
                : userRecord.Cell_Phone__c
            }}
          </h2>
        </div>

        <div class="sm:col-span-3" *ngIf="userRecord.Work_Phone__c">
          <mat-label class="font-bold">Work Phone</mat-label>
          <h2>
            {{
              userRecord.Work_Phone__c === "null"
                ? ""
                : userRecord.Work_Phone__c
            }}
          </h2>
        </div>
      </div>
    </div>

    <div class="loaderMain" *ngIf="pageLoader === true">
      <div>
        <img
          src="assets\TrailFusion\Trail-Fusion-logo.jpg"
          class="LoaderImage"
        />
        <p class="loaderText">{{ pageLoaderText }}</p>
      </div>
    </div>
  </div>

  <!-- Show edit form when userRecord exists and updateBtn is false -->
  <div
    *ngIf="userRecord && updateBtn === false"
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
    cdkScrollable
  >
    <form
      class="p-4 bg-card shadow rounded overflow-hidden"
      [formGroup]="profileForm"
      #parentProfileNgForm="ngForm"
      (ngSubmit)="onFormSubmit()"
    >
      <div class="w-full">
        <div class="text-xl font-bold">Profile Information</div>
      </div>

      <div class="mainDiv1">
        <!-- Show Parent Image Preview -->
        <div class="profile-image-container">
          <img
            [src]="
              imagePreviewParent
                ? imagePreviewParent
                : 'assets/images/avatars/user.png'
            "
            alt="Parent Image Preview"
            class="profile-image"
          />
        </div>

        <div class="upload-container">
          <label for="fileUploadParent" class="font-bold"
            >Upload User Image</label
          >
          <input
            type="file"
            id="fileUploadParent"
            (change)="onFileSelected($event, 'parent')"
            accept="image/*"
          />
          <div class="text-left font-bold">Image file size must be in KB</div>
        </div>

        <mat-error *ngIf="imageError"> Image must be less than 1MB. </mat-error>
      </div>

      <div class="my-5 border-t"></div>
      <br />
      <div class="mainDiv">
        <mat-form-field class="flex-auto gt-xs:pl-3 items">
          <mat-label>Full Name</mat-label>
          <input
            matInput
            [formControlName]="'pgiFullName'"
            (input)="onInputAlphabet($event)"
            [placeholder]="'Full Name'"
            required
          />
          <mat-error> Please enter full name</mat-error>
        </mat-form-field>

        <mat-form-field class="flex-auto gt-xs:pl-3 items">
          <mat-label>Email Address</mat-label>
          <input
            matInput
            [formControlName]="'pgiEmail'"
            [placeholder]="'Email Address'"
            readonly
          />
        </mat-form-field>
      </div>

      <div class="mainDiv">
        <mat-form-field class="flex-auto gt-xs:pl-3 items">
          <mat-label>Physical Address</mat-label>
          <input
            matInput
            [formControlName]="'pgiPhysicalAddress'"
            [placeholder]="'Physical Address'"
            required
          />
          <mat-error> Please enter physical Address</mat-error>
        </mat-form-field>

        <!-- <mat-form-field class="flex-auto gt-xs:pl-3 items">
          <mat-label>Community</mat-label>
          <input matInput [formControlName]="'community'" readonly />
        </mat-form-field> -->
        <mat-form-field class="flex-auto items">
          <mat-label>Town/City</mat-label>
          <input
            matInput
            [formControlName]="'pgiCity'"
            [placeholder]="'Town/City'"
            required
          />
          <mat-error> Please enter Town/City</mat-error>
        </mat-form-field>
      </div>

      <div class="mainDiv">
        <mat-form-field class="flex-auto items">
          <mat-label>Postal Code</mat-label>
          <input
            matInput
            [formControlName]="'pgiPostalCode'"
            (input)="onInputAlphaNumeric($event)"
            [placeholder]="'Postal Code'"
            required
          />
          <mat-error> Please enter Postal Code</mat-error>
        </mat-form-field>
        <mat-form-field class="flex-auto items">
          <mat-label>Primary Phone</mat-label>
          <input
            matInput
            [formControlName]="'pgiHomePhone'"
            (input)="onInputNumeric($event)"
            mask="(999) 999-9999"
            maxlength="14"
            [placeholder]="'Primary Phone'"
            required
          />
          <mat-error> Please enter primary phone</mat-error>
        </mat-form-field>
      </div>

      <div class="mainDiv">
        <mat-form-field class="flex-auto items">
          <mat-label>Cell Phone</mat-label>
          <input
            matInput
            [formControlName]="'pgiCellPhone'"
            (input)="onInputNumeric($event)"
            [placeholder]="'Cell Phone'"
          />
        </mat-form-field>
        <mat-form-field class="flex-auto items">
          <mat-label>Work Phone</mat-label>
          <input
            matInput
            [formControlName]="'pgiWorkPhone'"
            (input)="onInputNumeric($event)"
            [placeholder]="'Work Phone'"
          />
        </mat-form-field>
      </div>

      <div class="mainDiv"></div>

      <div class="text-center mt-8">
        <button
          class="px-8 ml-4 submit-button"
          mat-raised-button
          color="primary"
          *ngIf="updateBtn === false"
          [disabled]="profileForm.invalid"
          aria-label="EditCount"
        >
          Update
        </button>
      </div>
    </form>

    <div class="loaderMain" *ngIf="pageLoader === true">
      <div>
        <img
          src="assets\TrailFusion\Trail-Fusion-logo.jpg"
          class="LoaderImage"
        />
        <p class="loaderText">{{ pageLoaderText }}</p>
      </div>
    </div>
  </div>
</div>
